import styles from '../styles/Gaudi.module.css'
import GoBackSection from "../components/GoBackSection"

export default function Gaudi() {
  return (
    <div>
      <GoBackSection section="designs"/>
      <div className={styles.magazineContainer}>
        <p className={styles.title}>Gaudí’s Masterpieces - Magazine</p>
        <p style={{marginBottom: "30px"}}>
          <span style={{fontWeight: "800", color: "var(--color-darkblue)", paddingRight: '15px'}}>Tools used</span>
          Illustrator, Photoshop & Figma
        </p>
        <iframe 
          style={{border: "1px solid #777;", paddingBottom: "10px"}}
          src="https://indd.adobe.com/embed/4aa2ae1b-faab-4ba2-b777-253e661f1a77?startpage=1&allowFullscreen=true" 
          width="800px" 
          height="567px" 
          frameborder="0" 
          allowfullscreen=""
          >
        </iframe>
      </div>
    </div>
  )
}